import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

/**
 * Optimistic like button bound to a storage path (photo / video / story).
 * Receives optional initial { count, liked } so the parent (batch fetch) can hydrate.
 */
const LikeButton = ({ target, initial, size = "sm", onChange }) => {
  const { user } = useAuth();
  const [count, setCount] = useState(initial?.count || 0);
  const [liked, setLiked] = useState(!!initial?.liked);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (initial) {
      setCount(initial.count || 0);
      setLiked(!!initial.liked);
    }
  }, [initial]);

  const toggle = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!user) { toast("Inicia sesión para dar like"); return; }
    if (busy) return;
    setBusy(true);
    // optimistic
    const next = !liked;
    setLiked(next);
    setCount((c) => c + (next ? 1 : -1));
    try {
      const r = await api.post(`/likes/toggle?target=${encodeURIComponent(target)}`);
      setLiked(r.data.liked);
      setCount(r.data.count);
      onChange?.(r.data);
    } catch (err) {
      setLiked(!next);
      setCount((c) => c + (next ? -1 : 1));
    } finally { setBusy(false); }
  };

  const px = size === "lg" ? 22 : size === "md" ? 18 : 16;
  return (
    <button
      data-testid={`like-${target}`}
      type="button"
      onClick={toggle}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs transition select-none ${liked ? 'bg-[#D4AF37]/15 text-[#1A2118]' : 'bg-white/85 hover:bg-white text-[#1A2118]'} backdrop-blur-sm shadow-sm`}
      aria-label="Me gusta"
    >
      <Heart size={px} strokeWidth={1.6} className={liked ? "fill-[#D4AF37] text-[#D4AF37]" : "text-[#364531]"} />
      <span className="tabular-nums">{count}</span>
    </button>
  );
};

export default LikeButton;
